/* eslint-disable no-param-reassign */
import {
  getSession,
  setSession,
  getOrderIdSession,
  deleteSession,
  deleteCoaComplete,
  resetAppState,
} from '../utils/coaPersist';

const thirtyMinutes = 1000 * 60 * 30;

class InactivityRestart {
  timer;

  delay;

  constructor(delay) {
    this.delay = delay;
  }

  setTimer() {
    this.clearTimer();
    this.timer = setTimeout(() => {
      window.location = window.location.origin;
    }, this.delay);
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}

export default {
  install(Vue) {
    const restartApplicationTimer = new InactivityRestart(thirtyMinutes);
    Vue.prototype.$getSession = getSession;
    Vue.prototype.$getOrderIdSession = getOrderIdSession;

    Vue.prototype.$setSession = (uuid, orderId) => {
      setSession(uuid, orderId);
      restartApplicationTimer.setTimer();
    };

    Vue.prototype.$deleteSession = () => {
      restartApplicationTimer.clearTimer();
      deleteSession();
      deleteCoaComplete();
    };
    Vue.prototype.$resetAppState = () => {
      resetAppState();
    };
  },
};
